module.exports = new __parcel__URL__("program-board-app-skeleton.tpl.74f398b1.svg").toString();